import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function Screens() {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    const email = sessionStorage.getItem("userEmail");
    if (!email) {
      navigate("/signin");
    } else {
      setUserEmail(email);
    }
  }, [navigate]);

  // ?? Handle navigation
  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div style={{ padding: "40px", fontFamily: "Arial", textAlign: "center" }}>
      <h2 style={{ color: "blue", marginBottom: "20px" }}>
        Main Screen
      </h2>

      <p style={{ fontWeight: "bold", marginBottom: "30px" }}>
        Signed in as: {userEmail}
      </p>

      <button
        style={buttonStyle}
        onClick={() => handleNavigate("/recordexpenses")}
      >
        Record Expenses
      </button>

      <br />

      <button
        style={buttonStyle}
        onClick={() => handleNavigate("/incomestatement")}
      >
        Generate IncomeStatement
      </button>

      <br />

      <button
        style={buttonStyle}
        onClick={() => handleNavigate("/ledgerview")}
      >
        Generate Ledger
      </button>
    </div>
  );
}

const buttonStyle = {
  padding: "15px 30px",
  backgroundColor: "blue",
  color: "white",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "16px",
  marginBottom: "20px",
};

export default Screens;
